var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-item flex flex-direction justify-center align-center login-container min-body-height"},[_c('el-card',{class:(_vm.UI.isMobile ? 'full-item' : 'margin-bottom-100') +
        ' ' +
        (_vm.UI.clientHeight < 800 ? 'scroll-y' : '')},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("修改密码")])]),_vm._v(" "),_c('ChangePwd',{class:_vm.UI.isMobile ? 'mobile-login-box' : 'login-box'})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6299990f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/changePwd/index.vue
// module id = null
// module chunks = 